module.exports = __webpack_public_path__ + "static/avatar-bf5bb194aab5ab9b7bae0a83d71a7ba6.svg";